import { materialOrderNumber } from './materialOrderNumber.js';
import { materialOrderSummary } from './productionMaterialPlanning.js';

export function supplierPlanningGroups(groups, orders) {
  const suppliers = new Map();
  for (const group of groups) {
    const key = String(group.supplierId || group.supplier);
    if (!suppliers.has(key)) suppliers.set(key, { key, supplier: group.supplier, lines: [] });
    suppliers.get(key).lines.push({ ...group, toOrder: materialOrderSummary(group.needed, orders.filter(o => o.material_key === group.key)).toOrder });
  }
  return [...suppliers.values()];
}

export function supplierOrderReceipts(orders, batches) {
  return [...orders.filter(o => !o.supplier_order_id), ...batches.map(batch => ({
    ...batch,
    lines: orders.filter(o => o.supplier_order_id === batch.id).map(o => ({ ...o, ...o.supplier_order_line })),
  }))];
}

export function supplierOrderStatus(order) {
  if (order.lines.some(l => l.confirmed_quantity == null)) return 'Pedido';
  if (order.lines.every(l => Number(l.confirmed_quantity) === 0)) return 'Sin disponibilidad';
  return order.lines.every(l => Number(l.received_quantity || 0) >= Number(l.confirmed_quantity)) ? 'Recibido' : 'Confirmado';
}

export function supplierOrderDocumentText(order) {
  return `Pedido ${materialOrderNumber(order)}\nProveedor: ${order.supplier_name}\n\n${order.lines.map(line => `${line.name} · Ref. ${line.reference || 'Sin referencia'}\nColor: ${line.color}\nSolicitado: ${line.quantity} ${line.unit}\nConfirmado: ${line.confirmed_quantity == null ? 'Pendiente' : `${line.confirmed_quantity} ${line.unit}`}${line.expected_delivery_date ? `\nEntrega prevista: ${line.expected_delivery_date}` : ''}`).join('\n\n')}`;
}

export function supplierOrderConfirmationLines(order, values) {
  return order.lines.map(line => ({ id: line.id, revision: line.confirmation_revision, ...values[line.id] }));
}
